import { render } from "./ChatWidget.vue?vue&type=template&id=075f4cb3&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"

import "./ChatWidget.vue?vue&type=style&index=0&id=075f4cb3&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075f4cb3"]])

export default __exports__